import { KeyValuePair } from "@/Common/Models/UI/KeyValuePair";

interface ISelectKVPControlProps {
    Id?: string;
    dataCy?: string;
    Callback: (key: string) => void;
    Value: string;
    AvailableValues: KeyValuePair<string, string>[];
    IncludeEmptyChoice?: boolean;
    Placeholder?: string;
    style?: React.CSSProperties;
    isInvalid?: boolean;
}

class SelectKVPControl extends React.Component<ISelectKVPControlProps, never> {
    public render(): JSX.Element {
        let values = [...this.props.AvailableValues];

        if (this.props.IncludeEmptyChoice && !values.any(p => p.Key === ""))
            values.unshift(new KeyValuePair("", ""));

        let className = "form-control myle-control";
        if (this.props.isInvalid)
            className += " invalid";

        return (
            <select
                data-cy={this.props.dataCy}
                style={this.props.style}
                onChange={(e: any) => this.props.Callback?.(e.target.value)}
                className={className}
                value={this.props.Value}
            >
                <option value="" disabled hidden>{this.props.Placeholder}</option>
                {values.map(p =>
                    <option key={p.Key} value={p.Key}>{p.Value}</option>
                )}
            </select>
        );
    }
}

export { SelectKVPControl };
